import template from './features_roles.html';
import tr from '../../lib/default-translator.js';

class AdminFeaturesRolesViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_features_roles_help()
	{
		Grape.dialog.open('FeaturesRolesHelp');
	}
}

class AdminFeaturesRolesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminFeaturesRolesViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Features And Roles');
		window.current_page_title(tr('Manage Features And Roles'));
	}
}

export default {
	route: '[/]admin/features_roles',
	page_class: AdminFeaturesRolesPage,
	template: template,
	template_filename: 'translation/features_roles'
};
